import { Days } from '@taleemabad/dsm/components';
import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

interface TimetableContextProps {
  selectedDayItem: Days | null;
  shiftItem: string | null;
  setSelectedDayItem: (day: Days) => void;
  setShiftItem: (shift: string) => void;
  resetTimetableSelection: () => void;
}

export const TimetableContext = createContext<TimetableContextProps>(null!);

export const useTimetableContext = () => {
  const context = useContext(TimetableContext);
  if (!context) {
    throw new Error(
      'useTimetableContext must be used within a TimetableProvider',
    );
  }
  return context;
};

export const TimetableProvider = ({ children }: PropsWithChildren) => {
  const [selectedDayItem, setSelectedDayItem] = useState<Days | null>(null);
  const [shiftItem, setShiftItem] = useState<string | null>(null);
  const resetTimetableSelection = () => {
    setShiftItem(null);
    setSelectedDayItem(null);
  };
  const handleSetSelectedDayItem = (day: Days) => {
    setSelectedDayItem(day);
  };
  const handleSetShiftItem = (shift: string) => {
    setShiftItem(shift);
  };
  const value = useMemo(() => {
    return {
      selectedDayItem,
      shiftItem,
      setSelectedDayItem: handleSetSelectedDayItem,
      setShiftItem: handleSetShiftItem,
      resetTimetableSelection,
    };
  }, [selectedDayItem, shiftItem]);
  return (
    <TimetableContext.Provider value={value}>
      {children}
    </TimetableContext.Provider>
  );
};
